export enum WorkOverviewEntry {
  None = 0,
  Work = 1,
  Rest = 2,
  AdditionalWork = 3,
  // Breach = 4, Removed for now
  AdditionalRest = 5,
}
